<div class="row col-12 col-sm-12 my-account-container">
  <div class="col-3 col-sm-3 col-md-3 hidden-sm hidden-xs my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'MyRequestNavNode'"
      [childNavState]="'BreakApplicationFormSearchNAVNode'"></app-my-account-left-sidenav>
  </div>

  <div class="submit-warranty-claim col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
    <div class="my-section-box">
      @if (canLoadPage) {
      <form [formGroup]="warrantyClaimSearchForm">
        <div class="warranty-claim-application-block">
          <h1 class="warranty-claim-headling m-0">
            {{'common.text_bendix_search_text3'|cxTranslate}}
          </h1>
          <div class="warranty-claim-application-detail break-app-search">
            <div class="content paragraph-div">
              <p class="fs_16">{{'common.text_bendix_search_text1'|cxTranslate}}</p>
              <p>&nbsp;</p>
              <ul class="my-3">
                <li class="fs_16">{{'common.text_bendix_search_point1'|cxTranslate}}</li>
                <li class="fs_16">{{'common.text_bendix_search_point2'|cxTranslate}}</li>
                <li class="fs_16">{{'common.text_bendix_search_point3'|cxTranslate}}</li>
              </ul>
              <p> &nbsp;</p>
              <p class="fs_16">{{'common.text_bendix_search_text2'|cxTranslate}}</p>
            </div>
            <div class="warranty-customID-block na-ref-cust-info-box">
              <div class="fs-wrap form-group">
                <div class="fs-label-wrap">
                  <label class="control-label kbclass"
                    for="claimCustomerID">{{'common.text_warranty_search_customerID'|cxTranslate}}</label>
                  <div class=" px-0 col-xs-12 col-sm-12 col-md-12 col-lg-12  select-boxer"
                    (click)="showChild = !showChild">
                    <input type="text" formControlName="defaultSoldTo">
                  </div>
                  @if (showChild) {
                  <div class="warrentCustomerID">
                    <app-customer-id-drop-down [customerId]="customerIdFromCommonEnd" [pageSource]="'warrantyClaim'"
                      (dataEvent)="receiveData($event)"></app-customer-id-drop-down>
                  </div>
                  }
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <div class="form-group">
                  <label class="control-label kbclass"
                    for="warrantyClaimNo">{{'common.text_ADB_applicationNum'|cxTranslate}}</label>
                  <input id="warrantyClaimNo" formControlName="claimNumber" class="form-control" type="text" value="">
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                <div class="form-group">
                  <label class="control-label kbclass"
                    for="ClaimDateFrom">{{'common.text_request_search_claim_from_date'|cxTranslate}}</label>
                  <input class="form-control kb-datePickerIcon warranty-datePicker" formControlName="startDate"
                    placeholder="mm/dd/yyyy" bsDatepicker [maxDate]="today"
                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY',showWeekNumbers:false, displayOneMonthRange: true }">
                  <div>
                    @if ( (this.warrentyform.startDate.invalid && this.warrentyform.startDate.touched)) {
                    <span class="text-danger-show">
                      {{'common.general_required'|cxTranslate}}</span>
                    }
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                <div class="form-group">
                  <label class="control-label kbclass"
                    for="ClaimDateTo">{{'common.text_request_search_claim_to_date'|cxTranslate}}</label>
                  <input class="form-control kb-datePickerIcon warranty-datePicker" formControlName="endDate"
                    placeholder="mm/dd/yyyy" bsDatepicker [maxDate]="today"
                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY',showWeekNumbers:false, displayOneMonthRange: true }">
                  <div>
                    @if ( (this.warrentyform.endDate.invalid && this.warrentyform.endDate.touched)) {
                    <span class="text-danger-show">
                      {{'common.general_required'|cxTranslate}}</span>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="row bottom_Section_brakeAppsearch">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 showRequestCheckBox">
                @if (showcoWorkerFlag) {
                <div class="form-group">
                  <div class="checkbox checkboxSection" (click)="setvaluevice()">
                    <label>
                      <input type="checkbox" class="checkbox-cowoerkers" formControlName="coWorkerFlag">
                      {{'common.text_Show_adb_of_coworkers'|cxTranslate}}
                    </label>
                  </div>
                </div>
                }
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 text-right">
                    <button type="button" id="WarrantyReset" class="btn btn-default WarrantyReset blue-btn"
                      name="WarrantyReset"
                      (click)="warrantyClaimSearchForm.reset()">{{'common.text_account_reset'|cxTranslate}}</button>
                    <button type="submit" (click)="onSubmit()" class="btn btn-primary yellow-btn warranty-submit"
                      id="finalSubmit">{{'common.text_account_search'|cxTranslate}} <img
                        src="/icons/link-right-white.svg" alt="Link Icon"></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      @if (BrakeRequestsApiData&&!BrakeRequestsApiData?.searchRetsults) {
      <div class="row">
        <div class="col-md-12">
          <div class="account-section-content content-empty">
            {{'common.text_account_warranty_search_empty'| cxTranslate}}</div>
        </div>
      </div>
      }
      }
    </div>
    <!-- Table -->
    <div class="warrantCount">
      @if (BrakeRequestsApiData?.pagination?.totalResults) {
      <span>{{BrakeRequestsApiData?.pagination?.totalResults}}{{'common.text_company_manageUser_registration_totalResults'|cxTranslate|slice:3}}</span>
      }
      @if (!BrakeRequestsApiData?.pagination?.totalResults) {
      <span> 0 &nbsp;</span>{{'common.text_company_manageUser_registration_totalResults'|cxTranslate|slice:3}}
      }
    </div>
    <div class="WarrantyTableOuter">
      <table class="table table-bordered table-blue order-status-table warrantySearchTable">
        <thead>
          <tr>
            <th scope="col DateTh"> <a class="a-underline" (click)="sort()">
                <u>{{'common.text_generalInfo_submitdate'|cxTranslate}}</u>
                @if (sortByDate == 'asc') {
                &#8593;
                }
                @if (sortByDate == 'desc') {
                &#8595;
                }
              </a>
            </th>
            <th scope="col" class="warranty-search-refNo"> <a class="a-underline">
                {{'common.text_core_search_appNumber'|cxTranslate}}
              </a></th>
            <th scope="col" class="warranty-search-refNo"> <a class="a-underline">
                {{'common.text_headline_status'|cxTranslate}}
              </a>
            </th>
            <th scope="col"> <a class="a-underline">
                {{'common.text_generalInfo_comments'|cxTranslate}}
              </a></th>
            <th scope="col"> <a class="a-underline">
                {{'common.text_account_supporttickets_createTicket_attachement_label'|cxTranslate}}
              </a></th>
            <th scope="col"> <a class="a-underline">
                Assigned Bendix Eng.
              </a></th>
          </tr>
        </thead>
        @if (BrakeRequestsApiData?.searchRetsults) {
        <tbody>
          @for (item of BrakeRequestsApiData?.searchRetsults; track item) {
          <tr class="responsive-table-item">
            <td class="responsive-table-cell DateTh">
              <span class="d-lg-none">{{'common.text_generalInfo_submitdate'|cxTranslate}}</span>
              <span>{{item?.submitDate | date:dateFormat}}</span>
            </td>
            <td class="responsive-table-cell warranty-search-refNo">
              <span class="d-lg-none">{{'common.text_core_search_appNumber'|cxTranslate}}</span>
              @if ((item?.status == 'INREVIEW') || (item?.status == 'RECEIVED')) {
              <a (click)="openPopup(item.code)">{{ item.code}}</a>
              }
              @if ((item?.status == 'AWAITING') || (item?.status == 'REJECTED')) {
              <a (click)="navigateToUpdatePage(item.code,item?.status)">{{ item.code}}</a>
              }
              @if (item?.status == 'SAVED') {
              <a (click)="navigateToFormPage(item.code)">{{ item.code}}</a>
              }
            </td>
            <td class="responsive-table-cell">
              <span class="d-lg-none">{{'common.text_headline_status'|cxTranslate}}</span>
              @if (item?.status == 'INREVIEW') {
              {{'common.adb_approvalType_INREVIEW'|cxTranslate}}
              }
              @if (item?.status == 'RECEIVED') {
              {{'common.adb_approvalType_RECEIVED'|cxTranslate}}
              }
              @if (item?.status == 'AWAITING') {
              {{'common.adb_approvalType_AWAITING'|cxTranslate}}
              }
              @if (item?.status == 'REJECTED') {
              {{'common.adb_approvalType_REJECTED'|cxTranslate}}
              }
              @if (item?.status == 'SAVED') {
              {{'common.adb_approvalType_SAVED'|cxTranslate}}
              }
            </td>
            <td class="responsive-table-cell warranty-search-refNo view-center">
              @if (item?.customerAndAdmincomments && item?.customerAndAdmincomments.length > 0) {
              <a (click)="openComments(item?.customerAndAdmincomments)">{{'common.break_view_comments'|cxTranslate}}</a>
              }
            </td>
            <td class="responsive-table-cell">
              <span
                class="d-lg-none ">{{'common.text_account_supporttickets_createTicket_attachement_label'|cxTranslate}}</span>
              <a class="a-dark"
                (click)="downloadZip(item?.zipFileAttachment?.fileCode,item?.code)">{{item?.zipFileAttachment?.altText}}</a>
            </td>
            <td class="responsive-table-cell">
              <span class="d-lg-none">Assigned Bendix Eng.</span>
              <span>{{item?.firstName}}</span>
            </td>
          </tr>
          }
        </tbody>
        }
      </table>

      <!-- Pagination -->
      @if (BrakeRequestsApiData?.searchRetsults && (BrakeRequestsApiData.pagination.totalResults!==0)) {
      <div class="account-orderhistory-pagination warranty-pagination">
        <div class="product__list--wrapper">
          <div class="pagination-bar">
            <div class="pagination-toolbar">
              <div class="row sort-refine-bar">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 bottom-result">
                  <div class="pagination-result">
                    {{'common.search_page_showing_text'|cxTranslate}}
                    {{(BrakeRequestsApiData.pagination.pageSize *
                    BrakeRequestsApiData.pagination.currentPage)+1 }} -
                    @if (BrakeRequestsApiData.pagination.pageSize > BrakeRequestsApiData.pagination.totalResults) {
                    <span>
                      {{BrakeRequestsApiData.pagination.totalResults}} </span>
                    }
                    @if ((BrakeRequestsApiData.pagination.pageSize *(BrakeRequestsApiData.pagination.currentPage+1) <
                      BrakeRequestsApiData.pagination.totalResults)&&(BrakeRequestsApiData.pagination.pageSize <
                      BrakeRequestsApiData.pagination.totalResults)) { <span>
                      {{BrakeRequestsApiData.pagination.pageSize*(BrakeRequestsApiData.pagination.currentPage+1)}}
                      {{'common.search_page_of_text'|cxTranslate}}
                      {{BrakeRequestsApiData.pagination.totalResults}} </span>
                      }
                      @if ((BrakeRequestsApiData.pagination.pageSize *(BrakeRequestsApiData.pagination.currentPage+1) >
                      BrakeRequestsApiData.pagination.totalResults)&&(BrakeRequestsApiData.pagination.pageSize <
                        BrakeRequestsApiData.pagination.totalResults)) { <span>
                        {{BrakeRequestsApiData.pagination.totalResults}}
                        of {{BrakeRequestsApiData.pagination.totalResults}} </span>
                        }
                        {{'common.search_page_result_text'|cxTranslate}}
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 kb-pagination-right kb-pagination">
                  <kb-pagination [pagination]="BrakeRequestsApiData?.pagination" [defaultPage]="0"
                    (viewPageEvent)="postWarrantyData($event)">
                  </kb-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>